export const dictionary = {
    common: {
        ui: {
            menu: {
                main: {
                    sections: {
                        sensors: "Capteurs",
                        observations: "Observations",
                        modelling: "Modélisation",
                        mapFeatures: "Caractéristiques de la carte",
                        output: "Exportation & Rapport",
                        setUp: "Configuration",
                    },
                },
            },
        },
    },
    temporalUnits: {
        millis: { long: { singular: 'milliseconde', plural: 'millisecondes' }, short: { singular: 'ms', plural: 'ms' } },
        seconds: { long: { singular: 'seconde', plural: 'secondes' }, short: { singular: 'sec.', plural: 'sec.' } },
        minutes: { long: { singular: 'minute', plural: 'minutes' }, short: { singular: 'min.', plural: 'min.' } },
        hours: { long: { singular: 'heure', plural: 'heures' }, short: { singular: 'hr.', plural: 'hrs.' } },
        days: { long: { singular: 'jour', plural: 'jours' }, short: { singular: 'jour', plural: 'jours' } },
        weeks: { long: { singular: 'semaine', plural: 'semaines' }, short: { singular: 'sem.', plural: 'sems.' } },
        months: { long: { singular: 'mois', plural: 'mois' }, short: { singular: 'mois.', plural: 'mois.' } },
        quarters: { long: { singular: 'trimestre', plural: 'trimestres' }, short: { singular: 'tri.', plural: 'tris.' } },
        years: { long: { singular: 'année', plural: 'années' }, short: { singular: 'an.', plural: 'ans.' } },
    },
    timezone: "Fuseau horaire",
    custom: 'modifié',
    period: 'période',
};
